// @flow

export function themeToClassName (theme: ?string): string {
  if (!theme) {
    return ''
  }
  return `theme-${theme}`
}



// WEBPACK FOOTER //
// ./src/shared/helpers/themeToClassName.js